import type {SVGProps, FC} from 'react';

export const EmojiIcon: FC<SVGProps<SVGSVGElement>> = (props) => {
    return (
        <svg viewBox='0 0 24 24' fill='currentColor' xmlns='http://www.w3.org/2000/svg' {...props}>
            <path d='M14.5 12C15.3 12 16 11.3 16 10.5C16 9.7 15.3 9 14.5 9C13.7 9 13 9.7 13 10.5C13 11.3 13.7 12 14.5 12ZM8.5 12C9.3 12 10 11.3 10 10.5C10 9.7 9.3 9 8.5 9C7.7 9 7 9.7 7 10.5C7 11.3 7.7 12 8.5 12ZM7.11324 14.5C6.7612 14.5 6.52163 14.8544 6.69225 15.1623C7.62924 16.8534 9.42928 18 11.5 18C13.5707 18 15.3708 16.8534 16.3078 15.1623C16.4784 14.8544 16.2388 14.5 15.8868 14.5H7.11324Z'/>
            <path fillRule='evenodd' clipRule='evenodd' d='M11.5 20C15.6421 20 19 16.6421 19 12.5C19 8.35786 15.6421 5 11.5 5C7.35786 5 4 8.35786 4 12.5C4 16.6421 7.35786 20 11.5 20ZM11.5 22C16.7467 22 21 17.7467 21 12.5C21 7.25329 16.7467 3 11.5 3C6.25329 3 2 7.25329 2 12.5C2 17.7467 6.25329 22 11.5 22Z'/>
        </svg>
    );
};
